export default __webpack_public_path__ + "221ea08bd17ad70fdbb2b75444951001.svg";